import React from "react";
import Modal from "react-bootstrap/Modal";
import "./custom-modal.scss";
import ModalHeader from "react-bootstrap/esm/ModalHeader";

const CustomModal = ({
  children,
  show,
  setShow,
  size = "md",
  customClass,
  autoClose = false,
  isHeaderHide = false,
  /** Set false when the body contains a file input (OS picker conflicts with focus trap). */
  enforceFocus = true,
  /** Use "static" when the modal must not close on backdrop click (e.g. file upload with camera). */
  backdrop = true,
  /** Optional id of a visible title element (overrides default modal label id). */
  ariaLabelledBy,
}) => {
  return (
    <Modal
      show={show}
      onHide={() => {
        if (autoClose) setShow(false);
      }}
      centered
      enforceFocus={enforceFocus}
      backdrop={backdrop}
      dialogClassName="modal-900w"
      aria-labelledby={ariaLabelledBy ?? "example-custom-modal-styling-title"}
      size={size}
      className={`${customClass} `}
    >
      <Modal.Body className="custom-body default p-0 m-0" >
        {!isHeaderHide ? <div style={{background:"#15AA81",borderRadius:"3px 3px 0px 0px"}} className="d-flex justify-content-end ml-auto mt-0 pt-0 px-1" onClick={() => setShow(false)}>
          <small style={{color:"white",fontWeight:"700",cursor:"pointer"}} className="close-button" >
            Close
          </small>
        </div> : ""}
        {children}
      </Modal.Body>
    </Modal>
  );
};

export default CustomModal;
